import { render, staticRenderFns } from "./ModalBarang.vue?vue&type=template&id=2f971f1e&scoped=true"
import script from "./ModalBarang.vue?vue&type=script&lang=js"
export * from "./ModalBarang.vue?vue&type=script&lang=js"
import style0 from "./ModalBarang.vue?vue&type=style&index=0&id=2f971f1e&prod&lang=scss"
import style1 from "./ModalBarang.vue?vue&type=style&index=1&id=2f971f1e&prod&lang=scss&scoped=true"
import style2 from "./ModalBarang.vue?vue&type=style&index=2&id=2f971f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f971f1e",
  null
  
)

export default component.exports